export default "__VITE_ASSET__CM73qEg3__"